import React, { FunctionComponent, h } from "preact"; // eslint-disable-line @typescript-eslint/no-unused-vars

export interface IInput {
  keyId: string;
  isFile: boolean;
  handleChange?: (params: any) => void;
}

const FormInput: FunctionComponent<IInput> = ({ keyId, isFile, handleChange }) => {
  return (
    <input
      required
      name={keyId}
      className={isFile ? "base-form__input input input--file" : "base-form__input"}
      id={keyId}
      type={isFile ? "file" : "text"}
      accept={isFile ? "image/png, image/gif, image/jpeg" : null}
      onChange={isFile ? handleChange : null}
    ></input>
  );
};

export default FormInput;
